export const LOAD_STORED_STATE = 'manageLeads/loadStoredState';

export interface LoadStoredStateAction {
  type: typeof LOAD_STORED_STATE;
  payload: {
    manageLeads?: any;
    secondaryFilter?: any;
    quickFilter?: any;
  };
}
